import React, {Component} from "react";
import withStaticImages from '../../../services/utils/imageNameRetriever';

require("./welcome-popup.css");



class WelcomePopup extends Component {

    constructor(props) {
        super(props);


        this.state = {
            show_popup: false
        };
    }

    componentDidMount() {
        const POPUP_VERSION = 16;
        let popupVersion = parseInt(localStorage.getItem("welcome_popup1"), 10);

        //TO ENABLE THE POPUP - change to true!
        let showPopup = true;
        if (popupVersion === POPUP_VERSION) {
            showPopup = false;
        }


        if (showPopup) {
            localStorage.setItem("welcome_popup1", POPUP_VERSION);
        }

        this.setState({show_popup: showPopup});
    }

    hidePopup() {
        this.setState({show_popup: false});
    }


    render() {

       

        let {show_popup} = this.state;


        if (show_popup) {
            return (
                <div className='welcome_popup_container'>
                    <div className='welcome_popup_modal' onClick={this.hidePopup.bind(this)}>
                        <div className='welcome_popup_dialog'>
                            <div className='welcome_popup_close' onClick={this.hidePopup.bind(this)}>X</div>
                            <div className='welcome_popup_content'>
                                <img alt='welcome_popup_image' className='welcome_popup_image' src={this.props.getImage('functional_skills_pop-up.png')}></img>
                            </div>
                        </div>
                    </div>
                </div>    
             );
        }
        else {
            return "";
        }
        
    }
}

export default withStaticImages('images',WelcomePopup);



// WEBPACK FOOTER //
// ./src/components/containers/welcome-popup/welcome-popup.js